import { useFieldArray, useForm, useWatch } from "react-hook-form";
import useLabels from "../../hooks/useLabels";
import {
  DatePicker,
  Input,
  Label,
  MultipleSelect,
  Select,
  Submit,
  TextArea,
} from "../FormComponents";
import { useNavigate, useParams } from "react-router";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

// NEW: Import CacheManager for surgical cache updates
import CacheManager from "../../services/cacheManager";
import { useDispatch, useSelector } from "react-redux";
import {
  getOperations,
  newOperation,
  updateOperation,
} from "../../services/utils";
import {
  empty,
  setOperations,
  updateOp,
  add,
} from "../../context/operations/operationsSlice";
import { ConfirmationModal, CTA, DestinationSelector, mapTankToSelectOption, OperationRecap, SourceSelector, TankIcon } from "../Generic";
import {
  ALPHA_NUM_SPACE_DASH_UNDERSCORE_REGEX,
  INT_REGEX,
} from "../../constants/regex";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import { selectAllLotNames, selectOperations } from "../../context/selectors";
import { addMinutes, addMonths } from "date-fns";
import { DestTankDetail } from "../OperationsDetail/Details";
import { NavLink } from "react-router-dom";
import { emptyTanks } from "../../context/tanks/tanksSlice";
import { emptyLots } from "../../context/lots/lotsSlice";
import LotLabelTags from "../LotLabelTags";
import { toastAxios } from "../../services/toastAxios";

const CutForm = ({
  operation,
  activeWinery,
  tanks,
  users,
  configs,
  lots,
  type,
  isMobile,
  isDuplicate = false,
  onConfigSave,
}) => {
  const { id } = useParams();
  const [getLabel] = useLabels();
  const [isOpen, setIsOpen] = useState(false);
  const [isExactDate, setIsExactDate] = useState(false);
  const operations = useSelector(selectOperations);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const axiosPrivate = useAxiosPrivate();
  const lotNames = useSelector(selectAllLotNames);

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    reset,
    setValue,
    getValues,
    setError,
    clearErrors,
    control,
    trigger,
  } = useForm({
    defaultValues: {
      // dest_tanks: operation?.dest_tanks || [
      //   { tankData: { value: null, label: null } },
      // ],
      priority: operation?.priority || "",
      protocolFrequency: "",
      expire_date: operation?.expire_date || null,
      type: "CUT",
      src_tanks: operation?.src_tanks || [
        { tankData: { value: null, label: null }, quantity: 0 },
      ],
      tank_id_in: operation?.dest_tanks?.[0] || {},
      cellarman_ids: operation?.cellarman_ids || "",
      new_batch_name: operation?.new_batch_name || "",
    },
    mode: "onTouched",
  });

  useEffect(() => {
    if (id && (!operations || operations?.length === 0)) loadOperations();
    if (id && operations?.length > 0) {
      const operation = operations?.find((o) => o.id === Number(id)) || null;
      if (operation === null) return;

      setValue("priority", {
        label: getLabel(`operationPriority${operation?.priority}`),
        value: operation?.priority,
      });

      const srcs = [];

      operation?.src_tanks?.map((s) => {
        const tank = tanks?.find((t) => t.id === s.tank_id);

        srcs.push({
          quantity: s?.arrow_quantity,
          tankData: {
            // value: s?.tank_id,
            // label: tank?.name,
            // state: tank?.state,
            // availability: Number(tank?.quantity),
            // capacity: Number(tank?.capacity),
            // quantity: Number(tank?.quantity),
            // color: tank?.color,
            // lot: tank?.batch_name || getLabel("tankState_EMPTY"),
            // name: tank?.name + ` (${tank?.batch_name})`,

            value: tank?.id,
            label: tank?.name,
            // lot: lots.find((lot) => lot?.id == tank?.batch_id)
            //   ?.name,
            lot: tank?.batch_name,
            lot_id: tank?.batch_id || "",
            availability: Number(tank?.quantity),
            color: tank?.color,
            state: tank?.state,
            is_disabled: tank?.is_planned === true && !operation?.src_tanks?.find(s => s?.id == tank?.tank_id),
            icon: tank?.is_planned_src && (Number(tank?.quantity) > 0 && Number(tank?.quantity) !== Number(tank?.planned_quantity)) ? "fa-calendar" : null,
            name:
              tank?.name +
              ` (${lots?.find((lot) => lot?.id === tank?.batch_id)?.name ||
                getLabel("tankState_EMPTY")
              })`,
            capacity: Number(tank?.capacity),
            quantity: tank?.quantity,
            is_planned: tank?.is_planned,
            is_planned_src: tank?.is_planned_src,
            is_planned_state: tank?.is_planned_state,
            planned_quantity: tank?.planned_quantity,
            planned_subtype: tank?.planned_subtype,
            planned_batch_name: tank?.planned_batch_name,
            planned_batch_type: tank?.planned_batch_type,
            planned_batch_color: tank?.planned_batch_color,
            planned_batch_state: tank?.planned_batch_state,
            programmed_as_src: tank?.programmed_as_src,
            programmed_as_dest: tank?.programmed_as_dest,
            is_planned_by_other_ops: tank?.is_planned_src && tank?.programmed_as_src?.filter(p_id => id === null || p_id !== Number(id))?.length > 0,
          },
        });
      });
      srcTankFieldArray.replace(srcs);

      let dest = {};
      
      operation?.dest_tanks?.map((d) => {
        const tank = tanks?.find((t) => t.id === d.tank_id);
      
      const isPlannedByOtherOps = tank?.is_planned && (
        (id === null && tank?.programmed_as_dest?.length > 0) ||
        (id !== null && tank?.programmed_as_dest?.some(p_id => p_id !== Number(id))));
      
        // dest = {
        //   lot:
        //     lots?.find((lot) => lot?.id === tank?.batch_id)?.name ||
        //     getLabel("tankState_EMPTY"),
        //   value: tank?.id,
        //   label: tank?.name,
        //   availability:
        //     Number(tank?.capacity) - (id ? Number(tank?.quantity) : Number(tank?.planned_quantity)),
        //   capacity: Number(tank?.capacity),
        //   quantity: Number(tank?.quantity) + d?.arrow_quantity,
        //   arrow_quantity: d?.arrow_quantity,
        //   color: tank?.color,
        //   state: tank?.state,
        //   lot:
        //     lots?.find((lot) => lot?.id == tank?.batch_id)?.name ||
        //     getLabel("tankState_EMPTY"),
        //   is_planned_by_other_ops: isPlannedByOtherOps,
        //   is_disabled:
        //     tank?.is_planned_src === true ||
        //     Number(tank?.planned_quantity) ===
        //       Number(tank?.capacity),
        //   icon:
        //     (tank?.is_planned &&
        //       Number(tank?.planned_quantity) >= 0) ||
        //     tank?.is_planned_src > 0
        //       ? "fa-calendar"
        //       : null,
        //   name:
        //     tank?.name +
        //     ` (${
        //       tank?.is_planned && Number(tank?.planned_quantity) > 0
        //         ? tank?.planned_batch_name || ""
        //         : Number(tank?.quantity) <= 0
        //         ? getLabel("tankState_EMPTY")
        //         : lots?.find((lot) => lot?.id === tank?.batch_id)
        //             ?.name || getLabel("tankState_EMPTY")
        //     })`,
        //   is_planned: isPlannedByOtherOps && tank?.is_planned,
        //   is_planned_state: tank?.is_planned_state,
        //   planned_quantity: isPlannedByOtherOps ? tank?.planned_quantity : 0,
        //   planned_batch_name: isPlannedByOtherOps ? tank.planned_batch_name : '',
        //   planned_batch_type: tank?.planned_batch_type, 
        //   programmed_as_src: tank?.programmed_as_src,
        //   programmed_as_dest: tank?.programmed_as_dest,
        //   batch_name: d?.batch_name,

        // };
        const tankMap = mapTankToSelectOption(
          tank,
          "dest",
          lots,
          operation,
          getLabel
        )
        setValue("tank_id_in", tankMap);

        setValue("tank_id_in.batch_name_selector", {
          value: d?.is_new,
          label: d?.is_new ? getLabel("lotNewName") : d?.batch_name,
        });
        setValue("tank_id_in.new_batch_name", d?.is_new ? d?.batch_name : "");
        setValue("tank_id_in.new_batch_type", d?.new_batch_type || d?.is_new ? "NEW" : "OLD");
        
      });
      // setValue("tank_id_in", dest);

      const cellarmans = [];
      operation?.cellarman_ids?.map((u) => {
        const user = users?.find((us) => us.id === u);
        cellarmans.push({
          value: u,
          label: user?.username,
        });
      });
      setValue("cellarman_ids", cellarmans);

      if (operation?.expire_dates && operation?.expire_dates?.length > 0) {
        setValue("protocolFrequency", {
          label: getLabel("protocolRepeat"),
          value: "repeat",
        });
      } else {
        setValue("protocolFrequency", {
          label: getLabel("protocolSpot"),
          value: "spot",
        });
        setValue("expire_date", operation?.expire_date);
      }

      // TO DO: fix notes when updating
      setValue("note", operation?.note);

      // if (operation?.batch_name_out) {
      //   setValue('batch_name_selector', {
      //     value: true,
      //     label: getLabel('lotNewName')
      //   });
      //   setValue('new_batch_name', operation?.batch_name_out);
      // }
    }
  }, [operations, operation, tanks]);

  const loadOperations = async () => {
    const loadedOperations = await getOperations(axiosPrivate);
    dispatch(setOperations(loadedOperations));
  };

  const srcTankFieldArray = useFieldArray({
    control,
    name: "src_tanks",
  });
  
  const {
    fields,
    append,
    remove,
    replace,
    update,
  } = srcTankFieldArray;
  
  const { src_tanks, tank_id_in, subtype } = useWatch({ control });

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  const getTotalQuantity = () => {
    return (
      src_tanks?.reduce((acc, curr) => {
        return acc + (Number(curr?.quantity) || 0);
      }, 0) || 0
    );
  };

  const computeLotNames = () => {
    const names = new Set();
    src_tanks?.reduce((_, item) => names.add(item?.tankData?.lot), null);

    const state = src_tanks?.find(t => t?.tankData?.state)?.tankData?.state || null;
    // TO DO add check on state
    lotNames
      ?.filter((l) => l?.state === state)
      ?.reduce((_, l) => names.add(l?.name), null);

    src_tanks
      ?.filter((tank) => tank?.tankData?.quantity > 0 && tank?.tankData?.state === state)
      ?.reduce((_, item) => names.add(item?.tankData?.lot), null);

    const nameObjects = [];
    names?.forEach((s) => {
      if (s) nameObjects.push({ value: false, label: s });
    });

    return nameObjects?.sort((a, b) =>
      a?.label > b?.label ? 1 : b?.label > a?.label ? -1 : 0
    );
  };

  const customIdMissingSrcs = "custom-id-missing-srcs";
  const customIdUnavailableLotName = "custom-id-unavailable-lot-name";
  const customIdInvalidLotName = "custom-id-invalid-lot-name";
  const customIdInvalidQuantities = "custom-id-invalid-quantities";
  const openFormModal = () => {
    // trigger();
    if (src_tanks?.filter((t) => t?.tankData?.value)?.length === 0) {
      toast(getLabel("toast_destemmingMissingSrcs"), {
        toastId: customIdMissingSrcs,
        type: toast.TYPE.ERROR,
        isLoading: false,
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return;
    } else {
      toast.dismiss(customIdMissingSrcs);
    }

    if (
      tank_id_in?.batch_name_selector?.value === "" ||
      (!tank_id_in?.batch_name_selector?.value &&
        tank_id_in?.batch_name_selector?.label?.length === 0) ||
      (tank_id_in?.batch_name_selector?.value === true &&
        tank_id_in?.new_batch_name?.length === 0)
    ) {
      toast(getLabel("toast_cutMissingLotSelectors"), {
        toastId: customIdMissingSrcs,
        type: toast.TYPE.ERROR,
        isLoading: false,
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return;
    } else {
      toast.dismiss(customIdMissingSrcs);
    }

    // const filteredTanks = tank_id_in?.filter((d) => d?.tankData?.value);
    // if (filteredTanks?.length === 1)
    //   setValue(
    //     "tank_id_in.0.quantity",
    //     getTotalQuantity()
    //   );

    const indices = src_tanks?.map((_, i) => i);
    for (const idx of indices) {
      if (!checkTankValidity(idx, null, false)) return;
    }
    // if (!checkTankValidity(null, true)) return;

    setIsOpen(true);
    return;
    const cutLiters = getTotalQuantity();

    const totalKgAvailable =
      Number(tank_id_in?.tankData?.availability) || 0;
    if (cutLiters <= totalKgAvailable) {
      toast.dismiss(customIdInvalidQuantities);
      setIsOpen(true);
    } else {
      toast(
        getLabel("toast_cutInvalidQuantities", {
          sum: cutLiters || "0",
          total: totalKgAvailable,
        }),
        {
          toastId: customIdInvalidQuantities,
          type: toast.TYPE.ERROR,
          isLoading: false,
          position: toast.POSITION.BOTTOM_RIGHT,
        }
      );
      return;
    }
  };

  const customIdNewOp = "custom-id-new-op";
  const customIdUpdateOp = "custom-id-update-op";
  const sendData = async () => {
    const data = getValues();
    // console.log(data);
    
    const dests = [];

    const totalCutLiters = src_tanks?.reduce((acc, curr) => {
      return acc + (Number(curr?.quantity) || 0);
    }, 0);
    if (tank_id_in === null) return;
    
    if (
      tank_id_in?.value &&
      totalCutLiters > 0 &&
      ((tank_id_in?.is_planned && tank_id_in?.planned_batch_name) ||
        ((tank_id_in?.batch_name_selector?.value === true && tank_id_in?.new_batch_name) ||
        (tank_id_in?.batch_name_selector?.value === false &&
          tank_id_in?.batch_name_selector?.label)))
    ) {
      
      const tankData = tank_id_in?.tankData;
      
      const isPlanned =
        tankData?.value &&
        tankData?.is_planned_by_other_ops &&
        Number(tankData?.quantity) === 0 &&
        tankData?.is_planned;

      const new_batch_name = isPlanned
        ? tankData?.planned_batch_name
        : tank_id_in?.new_batch_name;

      const batch_name_label = tank_id_in?.batch_name_selector?.label;
      const batch_name_value = tank_id_in?.batch_name_selector?.value;

      const new_name = (
        batch_name_value || isPlanned ? new_batch_name : batch_name_label
      )?.trim();
      
      const isPlannedByOtherOps = tankData?.is_planned && (
        (id === null && tankData?.programmed_as_dest?.length > 0) ||
        (id !== null && tankData?.programmed_as_dest?.some(p_id => p_id !== Number(id))));
        
      const destLot =
        lots?.find((l) => l?.name === new_name && l.state === "MUST") || null;
      const type = destLot?.id && !isPlannedByOtherOps ? "OLD" : "NEW";
      if (type === null) {
        toast.error(getLabel("toast_invalidType"), {
          toastId: customIdInvalidLotName,
          position: toast.POSITION.BOTTOM_RIGHT,
          exclude: true,
          autoClose: 5000,
        });
        return;
      }

      const destTank = {
        tank_id: tank_id_in?.value,
        quantity: totalCutLiters,
        is_new:
          tank_id_in?.batch_name_selector?.value === true &&
          tank_id_in?.new_batch_name?.length > 0,
        new_batch_name: new_name,
        new_batch_type: type,
        old_batch_id:
          tanks?.find((t) => t.id === tank_id_in?.value)?.batch_id || "",
        old_quantity:
          tanks?.find((t) => t.id === tank_id_in?.value)?.quantity || 0,
        new_quantity:
          (Number(
            tanks?.find((t) => t.id === tank_id_in?.value)?.quantity || 0
          ) || 0) + totalCutLiters,
      };
      dests.push(destTank);
    }

    if (dests?.length === 0) {
      toast.error(getLabel("toast_missingDestTanks"), {
        toastId: customIdInvalidLotName,
        position: toast.POSITION.BOTTOM_RIGHT,
        exclude: true,
        autoClose: 5000,
      });
      return;
    }

    const tmpDate = new Date(data?.expire_date)?.setHours(23, 59, 59);

    const requestPayload = {
      src_tanks: data?.src_tanks?.map((srcT) => {
        return { tank_id: srcT?.tankData?.value, quantity: Number(srcT?.quantity) };
      }),
      dest_tanks: dests,
      priority: data.priority?.value,
      // expire_date: addMinutes(
      //   new Date(data?.expire_date)?.setHours(23, 59, 59),
      //   -new Date(data?.expire_date).getTimezoneOffset()
      // ).toISOString(),
      is_exact_date: isExactDate,
      expire_date: new Date(tmpDate)?.toISOString(),
      type: data?.type,
      winery_id: activeWinery?.id,
      cellarman_ids: data?.cellarman_ids?.map((cellMan) => cellMan?.value),
      // new_batch_name: (dest?.batch_name_selector?.value === true
      //   ? dest?.new_batch_name
      //   : dest?.batch_name_selector?.label
      // )?.trim(),
      note: data?.note,
    };
    console.log('requestPayload', requestPayload);

    if (onConfigSave) {
      onConfigSave({
        src_tanks: requestPayload.src_tanks,
        dest_tanks: requestPayload.dest_tanks,
        operation_params: {
          type: requestPayload.type,
        },
      });
      return;
    }

    // return;

    let response = null;
    if (id && !isDuplicate) {
      response = await toastAxios(
        () => updateOperation(id, requestPayload, axiosPrivate),
        customIdUpdateOp,
        { name: operation?.type || "" },
        getLabel,
      );
    } else {
      response = await toastAxios(
        () => newOperation(requestPayload, axiosPrivate),
        customIdNewOp,
        { name: operation?.type || "" },
        getLabel,
      );
    }
    console.log("response", response);

    if (response && response?.success) {
      const updated_op = response?.updated_data || null;
      // const updated_tanks = response?.updated_tanks || null;
      // const updated_batches = response?.updated_batches || null;
      // NEW: Pass affected_entities to updateStore for surgical cache updates
      updateStore(updated_op, response?.affected_entities);
      navClickHandler();
    }
  };

  // NEW: Updated to accept affected_entities for surgical cache updates
  const updateStore = async (payloadOp, affectedEntities) => {
    // TO DO update also involved batches and tanks
    if (id) {
      dispatch(updateOp(payloadOp));
    } else {
      dispatch(add(payloadOp));
    }

    // NEW: Surgical cache update using affected_entities
    if (affectedEntities) {
      const cacheManager = new CacheManager(dispatch, axiosPrivate);
      await cacheManager.processAffectedEntities(affectedEntities);
    }
    // ⚠️ FALLBACK: If backend doesn't return affected_entities yet
    else {
      dispatch(emptyLots());
      dispatch(emptyTanks());
    }

    // if (payloadTanks?.id) {
    //   dispatch(update(payloadTanks));
    // } else {
    //   dispatch(add(payloadTanks));
    // }

    // if (payloadBatches?.id) {
    //   dispatch(update(payloadBatches));
    // } else {
    //   dispatch(add(payloadBatches));
    // }
  };

  const navClickHandler = () => {
    if (id && !isDuplicate) {
      navigate(`/programming/cut/${id}`);
    } else {
      navigate("/programming");
    }
  };

  const getError = (idx, data, key) => {
    if (idx === null) return data?.[key] || null;

    if (
      !errors ||
      Object.keys(errors)?.length === 0 ||
      !data ||
      data?.length <= idx
    )
      return;

    return data?.[idx]?.[key] || null;
  };

  const colorCustomId = "custom-id-different-color";
  const stateCustomId = "custom-id-different-state";
  const quantitiesCustomId = "custom-id-invalid-quantities";
  const customIdInvalidDestSum = "custom-id-invalid-dest-sum";

  const checkColors = () => {
    const colors = new Set();
    src_tanks?.reduce(
      (_, item) =>
        item?.tankData?.color ? colors.add(item?.tankData?.color) : null,
      null
    );
    if (tank_id_in?.tankData?.color)
      colors.add(getValues("tank_id_in.tankData")?.color);
    
    if (colors?.size > 1) {
      toast(getLabel("toast_WarningDiffentWineColor"), {
        toastId: colorCustomId,
        type: toast.TYPE.WARNING,
        isLoading: false,
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: false,
      });
      return false;
    } else toast.dismiss(colorCustomId);
    return true;
  };

  const checkStates = () => {
    const states = new Set();
    src_tanks?.reduce(
      (_, item) =>
        item?.tankData?.state ? states.add(item?.tankData?.state) : null,
      null
    );
    if (tank_id_in?.tankData?.state)
      states.add(getValues("tank_id_in.tankData")?.state);

    if (states?.size > 1) {
      toast(getLabel("toast_WarningDiffentWineState"), {
        toastId: stateCustomId,
        type: toast.TYPE.WARNING,
        isLoading: false,
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: false,
      });
      return false;
    } else toast.dismiss(stateCustomId);
    return true;
  }

  const checkQuantities = (idx, isOpenModal) => {
 
    const totalQuantity = getTotalQuantity();
    const dest_tank = tank_id_in?.tankData || {};
    const previousTotalQuantity = id ? (operation?.src_tanks?.reduce((acc, curr) => {
      return acc + (Number(curr?.arrow_quantity) || 0);
    }, 0) || 0) : 0;

    const totalAvailability = ((Number(dest_tank?.capacity) - 
      (dest_tank?.is_planned ? Number(dest_tank?.planned_quantity) : Number(dest_tank?.quantity))) || 0) 
      + previousTotalQuantity;
    
    if (isOpenModal) {
      const indices = idx !== null ? [idx] : src_tanks?.map((_, i) => i);
      for (const i of indices) {
        //   setError(`src_tanks.${i}.quantity`, {
        //   type: "manual",
        //   message: getLabel("errorDestTankOperationQuantity"),
        // });
      }

      return false;
    } else {
      if (totalQuantity > totalAvailability && dest_tank?.value) {
        toast(getLabel("toast_cutInvalidQuantities", {
          sum: totalQuantity || "0",
          total: totalAvailability,
        }), {
          toastId: quantitiesCustomId,
          type: toast.TYPE.WARNING,
          isLoading: false,
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: false,
        });
        return false;
      } else toast.dismiss(quantitiesCustomId);
    }
    return true;
  }

  const checkTankValidity = (idx = null, selectedOption = null, isOpenModal = false) => {
    // check colors
    const c = checkColors();
    // check state
    const s = checkStates();
    // check quantities
    const q = checkQuantities(idx, isOpenModal);
    
    return c && s && q;
  };

  const getTankData = (idx, isSrc = false) => {
    const t = (isSrc ? src_tanks?.[idx] : tank_id_in) || {};
    const tankData = t?.tankData || null;
    
    if (tankData === null) return {};
    
    const quantity = isSrc
      ? Number(src_tanks?.[idx]?.quantity) || 0
      : -getTotalQuantity();

    const new_name = isSrc ? tankData?.lot : t?.new_batch_name || '';

    const isPlannedState = (isSrc ? tankData?.is_planned_src : tankData?.is_planned) === true;
    
    const srcLot =
      lots?.find((l) => l?.name === new_name 
        && l?.state === src_tanks?.[0]?.tankData?.state
        && (isSrc ? l?.status === "CONFIRMED" : tankData?.is_planned ? l?.status === 'PLANNED' : l?.status === 'CONFIRMED')
      ) ||
      null;
    // if (!isSrc) console.log('srcLot', srcLot, 'new_name', new_name, tankData)

    // const isPlannedByOtherOps =
    //   isPlannedState && srcLot?.shared_operation_ids?.length > 0
    //     ? id
    //       ? srcLot.shared_operation_ids.some((opId) => Number(opId) !== Number(id))
    //       : true
    //     : false;
    const programmedIds = isSrc ? tankData?.programmed_as_src : tankData?.programmed_as_dest;
    const isPlannedByOtherOps = isPlannedState && (
      (id === null && programmedIds?.length > 0) ||
      (id !== null && programmedIds?.some(p_id => p_id !== Number(id)))
    );

    const isPlanned = tankData?.value && isPlannedState && isPlannedByOtherOps;

    let new_batch_name = '';
    if (!isSrc) {
      const batch_name_value = t?.batch_name_selector?.value;
      const batch_name_label = t?.batch_name_selector?.label;

      const planned_batch_name = isPlanned
        ? tankData?.planned_batch_name
        : t?.new_batch_name;

      new_batch_name = (batch_name_value || isPlanned ? planned_batch_name : batch_name_label)?.trim();
    }

    // const operation = operations?.find((o) => o.id === Number(id)) || {};
    const programmedQuantity = isSrc && !id ? Number(tankData?.quantity) : isSrc && id ? Number(operation?.src_tanks?.find(s => s?.tank_id == tankData?.value)?.arrow_quantity) : !isSrc && id ? operation?.src_tanks?.reduce((acc, curr) => {
      return acc + (Number(curr?.arrow_quantity) || 0);
    }, 0) || 0 : 0;

    const availableQuantity = isPlanned ? Number(tankData?.planned_quantity || 0) : tankData?.quantity || 0;
    const availableFreeSpace = tankData?.capacity - availableQuantity + (isSrc ? 0 : 1) * programmedQuantity;
    let isInvalidArrowQuantity = false;
    if (isSrc) isInvalidArrowQuantity = Math.abs(quantity) > availableQuantity || quantity < 0;
    else isInvalidArrowQuantity = Math.abs(quantity) > availableFreeSpace;

    // console.log('isSrc', !isSrc, 'isInvalidArrowQuantity', isInvalidArrowQuantity)
    // if (!isSrc && isInvalidArrowQuantity) {
      
    //   const toastMessage = getLabel("toast_invalidSumProgrammedOps", { name: tankData?.label, value:  availableFreeSpace});
    //   toast.error(toastMessage, {
    //     toastId: customIdInvalidDestSum,
    //     position: toast.POSITION.BOTTOM_RIGHT,
    //     exclude: true,
    //     autoClose: 5000,
    //   });
    // } else if (!isInvalidArrowQuantity) {
    //   toast.dismiss(customIdInvalidDestSum);
    // }

    const tank = {
      is_src: isSrc,
      remove_quantity: quantity,
      type: tankData?.type,
      barrels_num: tankData?.barrels_num,
      name: tankData?.label,
      color: tankData?.color || src_tanks?.[0]?.tankData?.color,
      old_quantity: isPlannedByOtherOps && isSrc ? Number(tankData?.planned_quantity) : tankData?.quantity,
      old_batch_name: id ? tankData?.lot : isPlanned && !isSrc ? null : tankData?.lot,
      batch_name: isSrc ? tankData?.lot : new_batch_name,
      quantity: tankData?.quantity - (isInvalidArrowQuantity ? 0 : quantity),
      planned_batch_name: isPlanned && !isSrc ? new_batch_name || "" : '',
      // planned_subtype: tank?.planned_subtype,
      // planned_batch_color: tank?.planned_batch_color,
      // planned_batch_state: tank?.planned_batch_state,
      planned_quantity: 
        !isPlannedByOtherOps && !isSrc
         ? 0
          : isPlannedByOtherOps && isSrc 
            ? (programmedQuantity) 
            : availableQuantity + (isSrc ? 1 : -1) * programmedQuantity,
      arrow_quantity: isInvalidArrowQuantity ? 0 : Math.abs(quantity),
      capacity: tankData?.capacity,
      is_planned: isPlannedByOtherOps && isPlannedState,
      is_planned_by_other_ops: isPlannedByOtherOps,
    };
    if (isSrc && id && isPlannedByOtherOps) {
      tank.planned_quantity = tankData?.quantity
      tank.old_quantity = tank.old_quantity + programmedQuantity;
    }

    return tank;
  };

  const getDestTankData = () => {
    const totalCutQuantity = src_tanks?.reduce((acc, curr) => {
      return acc + (Number(curr?.quantity) || 0);
    }, 0);
    const quantity = totalCutQuantity > tank_id_in?.availability ? 0 : totalCutQuantity; // TO DO: recheck this with real data

    const tank = {
      ...tank_id_in,
      state: tank_id_in?.state || tank_id_in?.quantity === 0 && type === "CUT" ? src_tanks?.[0]?.tankData?.state || null : null,
      add_quantity: totalCutQuantity,
      color: tank_id_in?.color || src_tanks?.[0]?.tankData?.color,
      name: tank_id_in?.label,
      old_quantity: tank_id_in?.quantity,
      old_batch_name: tank_id_in?.quantity > 0 ? tank_id_in?.lot : null,
      batch_name: tank_id_in?.is_planned ? tank_id_in?.planned_batch_name :
      tank_id_in?.batch_name_selector?.value === true
          ? tank_id_in?.new_batch_name
          : tank_id_in?.batch_name_selector?.label,
      quantity: tank_id_in?.quantity + quantity,
      arrow_quantity: quantity,
      planned_quantity: tank_id_in?.is_planned_by_other_ops ? tank_id_in?.planned_quantity : 0,
    };
    console.log('')
    
    return tank;
  };

  const processSrcTanks = () => {
    return src_tanks?.map((src, i) => {
      const tank = getTankData(i, true);

      return { ...tank, remove_quantity: src?.quantity, quantity: tank?.old_quantity - Number(src?.quantity), 
        planned_quantity: tank?.is_planned_by_other_ops ? tank?.planned_quantity : 0 };
    })?.reverse();
  }

  const getSrcTankMax = (idx) => {
    const tankData = src_tanks?.[idx]?.tankData;
    const previousQuantity = id ? operation?.src_tanks?.find(s => s?.tank_id === tankData?.value)?.arrow_quantity : 0;  // if is an update, do not count previous arrow_quantity
    const maxVal = (!tankData?.is_planned_src ? tankData?.availability : Number(tankData?.planned_quantity)) + previousQuantity;

    return {
      value: Number(maxVal) ?? null,
      message: getLabel("errorMaxValue", {
        value:
        maxVal ?? null,
      })
    }
  }

  const checkAvailableQuantity = (tankData, quantity) => {
    const new_name = tankData?.lot || '';

    const isPlannedState = tankData?.is_planned_src === true;
    
    const srcLot =
      lots?.find((l) => l?.name === new_name && l?.status === "CONFIRMED" && l?.state === tankData?.state || (l?.name === tankData?.planned_batch_name && l?.status === 'PLANNED')) ||
      null;

    // const isPlannedByOtherOps2 = id ? 
    //   srcLot?.shared_operation_ids?.some(opId => Number(opId) !== Number(id)) || false
    //   : srcLot?.shared_operation_ids?.length > 0;

    // const isPlannedByOtherOps =
    // tankData?.is_planned && srcLot?.shared_operation_ids?.length > 0
    //   ? id
    //     ? srcLot.shared_operation_ids.some((opId) => Number(opId) !== Number(id))
    //     : true
    //   : false;
    const isPlannedByOtherOps = isPlannedState && (
      (id === null && tankData?.programmed_as_src?.length > 0) ||
      (id !== null && tankData?.programmed_as_src?.some(p_id => p_id !== Number(id))));
  
    const isPlanned = tankData?.value && isPlannedState && isPlannedByOtherOps;         
    const previousQuantity = id ? operation?.src_tanks?.find(s => s?.tank_id === tankData?.value)?.arrow_quantity : 0;
                   
    const availableQuantity = (isPlanned ? Number(tankData?.planned_quantity || 0) : tankData?.quantity || 0) + previousQuantity;
    // console.log('quantity', quantity, 'availableQuantity', availableQuantity)

    if (quantity > availableQuantity) {
      return false;
    }
    const totalQuantity = getTotalQuantity();
    const dest_tank = tank_id_in?.tankData || {};
    const previousTotalQuantity = id ? (operation?.src_tanks?.reduce((acc, curr) => {
      return acc + (Number(curr?.arrow_quantity) || 0);
    }, 0) || 0) : 0;
    
    const totalAvailability = ((Number(dest_tank?.capacity) - (dest_tank?.is_planned ? Number(dest_tank?.planned_quantity) : Number(dest_tank?.quantity))) || 0)
    -previousTotalQuantity;
    // console.log('totalQuantity', totalQuantity, 'totalAvailability', totalAvailability)
    if (totalQuantity <= totalAvailability) toast.dismiss(quantitiesCustomId);

    return true;
  }

  return (
    <div className="operation_form_wrapper">
      {operations && (
        <form
          onSubmit={handleSubmit(openFormModal, (errors) => console.log("Form validation errors:", errors))}
          autoComplete="off"
          noValidate
        >
          <DestinationSelector
            id={id}
            type={type}
            subtype={subtype?.value}
            operation={operation}
            register={register}
            control={control}
            errors={errors}
            clearErrors={clearErrors}
            setValue={setValue}
            tanks={tanks}
            lots={lots}
            tank_id_in={tank_id_in}
            fields={fields}
            append={append}
            update={update}
            remove={remove}
            // getTankData={getTankData}
            // lotTypeMap={lotTypeMap}
            // setLotTypeMap={setLotTypeMap}
            isMobile={isMobile}
            baseName={"src_tanks"}
            watchedArray={src_tanks}
            lotNames={lotNames}
            isWizardMode={!!onConfigSave}
          />
          <SourceSelector
            id={id}
            type={type}
            configs={configs}
            subtype={subtype?.value}
            operation={operation}
            control={control}
            errors={errors}
            register={register}
            tanks={tanks}
            lots={lots}
            tank_id_in={tank_id_in}
            dest_tanks={src_tanks}
            lotNames={lotNames}
            getValues={getValues}
            setValue={setValue}
            isMobile={isMobile}
          />
          <div className="operation_form_wrapper_row">
            <MultipleSelect
              name={`cellarman_ids`}
              control={control}
              label={getLabel("operationUser")}
              placeholder={getLabel("operationUserPlaceholder")}
              error={errors["cellarman_ids"]}
              required={getLabel("inputRequiredError")}
              options={users?.map?.((user) => {
                return {
                  value: user?.id,
                  label: user?.username,
                };
              })}
              tooltip={getLabel("destemmingCellarmenTooltip")}
            />
            <Select
              name={"priority"}
              control={control}
              label={getLabel("operationPriority")}
              placeholder={getLabel("operationPriorityPlaceholder")}
              error={errors}
              required={getLabel("inputRequiredError")}
              options={[
                {
                  label: getLabel("lotQuality_HIGH"),
                  value: 2,
                },
                {
                  label: getLabel("lotQuality_MEDIUM"),
                  value: 1,
                },
                {
                  label: getLabel("lotQuality_LOW"),
                  value: 0,
                },
              ]}
              // defaultValue={{
              //     value: "",
              //     label: "",
              //   }}
            />
            {/* <Select
            name={"protocolFrequency"}
            control={control}
            label={getLabel("protocolFrequency")}
            placeholder={getLabel("protocolFrequencyPlaceholder")}
            error={errors}
            required={getLabel("inputRequiredError")}
            options={[
              {
                label: getLabel("protocolSpot"),
                value: "spot",
              },
              {
                label: getLabel("protocolRepeat"),
                value: "repeat",
              },
            ]}
            // defaultValue={[
            //   {
            //     label: getLabel("protocolSpot"),
            //     value: "spot",
            //   },
            // ]}
          /> */}
            <DatePicker
              name="expire_date"
              control={control}
              label={getLabel("operationExpireDateForm")}
              error={errors["expire_date"]}
              required={getLabel("inputRequiredError")}
              dateFormat={configs.shortDateFormat}
              placeholder={getLabel("expiringDatePlaceholder")}
            />
            {getValues("expire_date") && (
              <Input
                name={"expire_date_exact"}
                register={register}
                label={getLabel("isExactDate")}
                error={errors["expire_date_exact"]}
                // isLabel={false}
                type={"checkbox"}
                checked={isExactDate}
                onChange={() => setIsExactDate((prev) => !prev)}
                customClassName={"confirm no_margin_top"}
                tooltip={getLabel("destemmingExactDate")}
              />
            )}
          </div>
          <div className="client_form_wrapper_row">
            <TextArea
              name="note"
              register={register}
              label={getLabel("clientNotes")}
              placeholder={getLabel("clientNotesPlaceholder")}
              error={errors["note"]}
            />
          </div>
          {!onConfigSave && (
            <div className="operation_form_wrapper_row">
              <Submit label={getLabel("submitForm")}></Submit>
            </div>
          )}
        </form>
      )}
      <ConfirmationModal
        isOpen={isOpen}
        onConfirm={sendData}
        onClose={handleCloseModal}
        description={getLabel("modalNewCutDescription", {
          name: operation?.id || "",
        })}
        isOperationRecap={true}
        totalStep={0}
        errors={errors}
        getValues={getValues}
      >
        <OperationRecap
          type={"CUT"}
          control={control}
          register={register}
          getValues={getValues}
          errors={errors}
          lots={lots}
          allLotNames={lots?.map((l) => l.name)}
          src_tanks={processSrcTanks()}
          dest_tanks={[getDestTankData()]}
        />
      </ConfirmationModal>
    </div>
  );
};

export default CutForm;
